import { render, staticRenderFns } from "./HomeGoodList.vue?vue&type=template&id=311c540c&scoped=true&"
import script from "./HomeGoodList.vue?vue&type=script&lang=js&"
export * from "./HomeGoodList.vue?vue&type=script&lang=js&"
import style0 from "./HomeGoodList.vue?vue&type=style&index=0&id=311c540c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c540c",
  null
  
)

export default component.exports